import React from 'react';
import Color from 'color';

import { Text } from 'widget/components';
import { useIsPrimaryDark } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';

interface DocIcon {
  filename: string | undefined;
}

const DocIcon = ({ filename }: DocIcon) => {
  const { widget } = useWidgetContext();
  const isPrimaryDark = useIsPrimaryDark();

  const { colors } = widget;
  const color = isPrimaryDark ? 'white' : 'dark';

  const ext = filename
    ?.substring(filename.lastIndexOf('.') + 1)
    .substring(0, 4);

  const fill = isPrimaryDark
    ? colors.primary
    : Color(colors.primary).grayscale().hex();

  const dark = Color(fill).darken(0.2).hex();

  return (
    <div className="whatcrm-widget-doc-icon">
      <svg
        fill="none"
        height="40"
        viewBox="0 0 40 40"
        width="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 9.7561C0.5 4.36795 4.86795 0 10.2561 0H27.8171L40.5 12.6829V30.2439C40.5 35.632 36.132 40 30.7439 40H10.2561C4.86795 40 0.5 35.632 0.5 30.2439V9.7561Z"
          fill={fill}
        />

        <path
          d="M27.8171 0L40.5001 12.6829H32.6952C30.0011 12.6829 27.8171 10.4989 27.8171 7.80488V0Z"
          fill={dark}
        />
      </svg>

      <Text color={color} fontWeight={500} textAlign="center">
        {ext}
      </Text>
    </div>
  );
};

export default DocIcon;
